import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Restricted from '../../common/restricted'

import RequirementList from './requirement-list/list'

class Requirements extends Component {
  render() {
    const { view, rider } = this.props

    return (
      <section className="requirements">
        <div className="section-head">
          <h2>Requirements</h2>
        </div>

        {
          view.loggedIn
          ? <div className="subsection">
              <div className="section-head">
                <h3>Technical Requirements</h3>
              </div>

              <RequirementList
                view={view}
                requirements={{
                  group: 'tech_requirements',
                  class: 'requirement',
                  title: 'Technical requirement'
                }}
                items={rider.tech_requirements}
                addRiderItem={this.props.addRiderItem}
                removeRiderItem={this.props.removeRiderItem}
                createRiderItem={this.props.createRiderItem}
                editRiderItem={this.props.editRiderItem}
                moveRiderItem={this.props.moveRiderItem}
                deleteRiderItem={this.props.deleteRiderItem} />
            </div>
          : <Restricted
              section="Requirements"
              setModal={this.props.setModal} />
        }

        {
          view.loggedIn
          ? <div className="subsection">
              <div className="section-head">
                <h3>Non-Technical Requirements</h3>
              </div>

              <RequirementList
                view={view}
                requirements={{
                  group: 'non_tech_requirements',
                  class: 'requirement',
                  title: 'Non-technical requirement'
                }}
                items={rider.non_tech_requirements}
                addRiderItem={this.props.addRiderItem}
                removeRiderItem={this.props.removeRiderItem}
                createRiderItem={this.props.createRiderItem}
                editRiderItem={this.props.editRiderItem}
                moveRiderItem={this.props.moveRiderItem}
                deleteRiderItem={this.props.deleteRiderItem} />
            </div>
          : null
        }
      </section>
    )
  }
}

Requirements.propTypes = {
  view: PropTypes.object,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  moveRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  setModal: PropTypes.func
}

Requirements.defaultProps = {
  view: {},
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  editRiderItem: function() {},
  moveRiderItem: function() {},
  deleteRiderItem: function() {},
  setModal: function() {}
}

export default Requirements



// WEBPACK FOOTER //
// ./src/components/rider/rider-requirements/requirements.js